import React from "react"
import Illustration from "./illustration"
import Search from "./search"

function Screen1() {
  return (
    <div className='screen1'>
      <Search />
      <Illustration />
    </div>
  )
}

export default Screen1
